// HUD（トップバー直下の帯）。状態の表示専用。操作は置かない。
//
// ⚠️ 供給源が無い項目は出さない。ダミー値を置かない（UIUX仕様書 v1.1 §2）。
//   確定版の例示にあった「遅延 n便」は**ドメインに概念が無い**ため実装しない
//   （src/ の「遅延」は auth.js の認証イベント遅延のコメント1件のみ・2026-08-24 実測）。
//
// 出す項目:
//   月        … data/selectedMonth.js（先頭・--signal で強調）
//   稼働      … ビューが setHud({ active: '65/72台' }) で渡す
//   実車率    … 同上。未取込の月は null を渡す → ダッシュ（0% とは区別する）
//   最終同期  … markSynced() を呼んだ時刻。データ取得が成功した時だけ動く
//
// 値を渡されていない項目は **DOMごと出さない**。「—」すら出さない。
// 「—」は「データが無い」を意味する（§5）ので、「まだ誰も測っていない」とは別物。

const S = { month: '', active: null, ratio: null, syncedAt: null }

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
))

// YYYY-MM → 2026年08月
function ym(m) {
  const s = String(m || '')
  const hit = /^(\d{4})-(\d{2})/.exec(s)
  return hit ? `${hit[1]}年${hit[2]}月` : ''
}

function hhmmss(d) {
  const p = (n) => String(n).padStart(2, '0')
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
}

function item(label, value, cls) {
  // value が null/'' の項目は描かない（ダミーを出さないため）
  if (value === null || value === undefined || value === '') return ''
  return `<span class="ct-hud__item ${cls || ''}">${esc(label)}${label ? ' ' : ''}<span class="ct-hud__v">${esc(value)}</span></span>`
}

// 実車率だけは「未取込」を明示したいことがある。null=項目ごと出さない / '—'=データ無し
function ratioItem(v) {
  if (v === null || v === undefined) return ''
  const none = v === '—'
  return `<span class="ct-hud__item">実車率 <span class="ct-hud__v${none ? ' is-none' : ''}">${esc(v)}</span></span>`
}

export function hudHtml() {
  return `<div class="ct-hud" id="ct-hud">${hudInner()}</div>`
}

function hudInner() {
  return [
    item('', ym(S.month), 'is-lead'),
    item('稼働', S.active),
    ratioItem(S.ratio),
    S.syncedAt ? `<span class="ct-hud__item is-tail">最終同期 <span class="ct-hud__v">${esc(hhmmss(S.syncedAt))}</span></span>` : '',
  ].join('')
}

function paint() {
  const el = document.getElementById('ct-hud')
  if (el) el.innerHTML = hudInner()
}

/** ビューから状態を渡す。渡さなかったキーは維持される。 */
export function setHud(fields = {}) {
  for (const k of ['month', 'active', 'ratio']) {
    if (k in fields) S[k] = fields[k]
  }
  paint()
}

/** データ取得が成功した時に呼ぶ。これが「最終同期」の唯一の供給源。 */
export function markSynced(at) {
  S.syncedAt = at instanceof Date ? at : new Date()
  paint()
}

/** 画面を離れる・月を変える等で状態を捨てる（前の画面の数字を持ち越さない） */
export function resetHud() {
  S.active = null
  S.ratio = null
  paint()
}
